<div class="modal-header">
  <button type="button" class="close" ng-click="$close()">×</button>
  <h3 class="modal-title">Editar Plantio</h3>
</div>
<div class="modal-body edit-plantio-modal">
  <form name="editPlantioForm" class="form-horizontal">
    <div class="form-group" ng-class="{'has-error': editPlantioForm.atividade.$invalid}">
      <label for="atividade" class="control-label col-xs-3">Atividade</label>
      <div class="col-xs-9">
        <ui-select name="atividade" id="atividade" ng-model="$ctrl.atividade" required ng-change="$ctrl.changeAtividade()">
          <ui-select-match placeholder="Atividade">{{$select.selected.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="atividade in $ctrl.atividades | filter: $select.search">
            <span ng-bind-html="atividade.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="form-group" ng-class="{'has-error': editPlantioForm.cultivar.$invalid}">
      <label for="cultivar" class="control-label col-xs-3">Cultivar</label>
      <div class="col-xs-9">
        <ui-select name="cultivar" id="cultivar" ng-model="$ctrl.cultivar" required>
          <ui-select-match placeholder="Cultivar">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="cultivar in $ctrl.cultivares | filter: $select.search">
            <span ng-bind-html="cultivar.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="form-group" ng-class="{'has-error': editPlantioForm.periodo.$invalid}">
      <label for="periodo" class="control-label col-xs-3">Período</label>
      <div class="col-xs-9">
        <ui-select name="periodo" id="periodo" ng-model="$ctrl.periodo" required>
          <ui-select-match placeholder="Período">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="periodo in $ctrl.periodos | filter: $select.search">
            <span ng-bind-html="periodo.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="form-group" ng-class="{'has-error': editPlantioForm.area.$invalid}">
      <label for="area" class="control-label col-xs-3">Área</label>
      <div class="col-xs-9">
        <div class="input-group">
          <input type="number" name="area" id="area" ng-model="$ctrl.area" required min="0.01" class="form-control">
          <span class="input-group-addon">ha</span>
        </div>
      </div>
    </div>

    <div class="form-group" ng-class="{'has-error': editPlantioForm.dataInicio.$invalid}">
        <label for="area" class="control-label col-xs-3">Data Início</label>
        <div class="col-xs-9">
          <input type="date" name="dataInicio" id="dataInicio" ng-model="$ctrl.dataInicio" class="form-control">
        </div>
      </div>

      <div class="form-group" ng-class="{'has-error': editPlantioForm.dataFim.$invalid}">
      <label for="area" class="control-label col-xs-3">Data Fim</label>
      <div class="col-xs-9">
        <input type="date" name="dataFim" id="dataFim" ng-model="$ctrl.dataFim" class="form-control">
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$ctrl.deleteSimples()" ng-disabled="$ctrl.saving">
    Excluir
    <span ng-show="$ctrl.deleting">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
  </button>
  <button type="button" class="btn btn-white" ng-click="$close()">Cancelar</button>
  <button type="button" class="btn btn-primary"
          ng-click="$ctrl.save()"
          ng-disabled="editPlantioForm.$invalid || $ctrl.invalidDates() || editPlantioForm.$pristine || $ctrl.saving"
  >
    Salvar
    <span ng-show="$ctrl.saving">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
  </button>
</div>
